import { useMemo } from 'react'
import { Menu, Typography } from 'antd'
import { useRecoilState, useRecoilValue } from 'recoil'
import { floorDetailState, listPointState } from 'store/buildingStore'
import currentViewerState from 'store/viewerStore'

import RotatedArrowIcon from 'components/icons/RotatedArrowIcon'

import ViewerPointImages from './ViewerPointImages'

export default function ViewerAreaDropdown() {
  const [currentViewer, setCurrentViewer] = useRecoilState(currentViewerState)
  const points = useRecoilValue(listPointState)
  const floorDetail = useRecoilValue(floorDetailState)

  const sortedPointList = useMemo(
    () => [...points].sort((a, b) => a.order - b.order),
    [points]
  )
  const areas = useMemo(() => floorDetail?.areas || [], [floorDetail?.areas])

  const handleOpenMenu = (id: any) =>
    setCurrentViewer((prev) => ({
      ...prev,
      selectedArea: id !== prev.selectedArea ? id : undefined
    }))

  const listArea = areas.map((area) => {
    const children = sortedPointList
      .filter((point) => point.areaId === area.id)
      .map((item) => ({
        key: item.id,
        label: <ViewerPointImages point={item} />
      }))
    return {
      key: `${area.id}`,
      label: (
        <div className="flex" onClick={() => handleOpenMenu(`${area.id}`)}>
          <Typography.Text
            className="text-white text-[13px] leading-[19.5px]"
            ellipsis={{
              tooltip: area.name
            }}
          >
            {area.name}
          </Typography.Text>
          <RotatedArrowIcon
            fill="#609DF9"
            className={`transition-all ml-auto ${
              currentViewer.selectedArea === `${area.id}` ? '' : '-rotate-90'
            }`}
          />
        </div>
      ),
      children
    }
  })

  return (
    <Menu
      theme="dark"
      mode="inline"
      items={listArea}
      openKeys={
        currentViewer.selectedArea ? [currentViewer.selectedArea] : undefined
      }
      className="custom-list-area-dropdown !w-full overflow-auto"
      expandIcon={() => null}
    />
  )
}
